import {createReducer} from "redux-act";
import * as actions from "modules/actions";
import {ILeague} from "modules/types";

export interface IFetchLeague {
	id: number;
}

export interface IFetchLeagueReducer {
	league: ILeague | null;
}

const initialState: IFetchLeagueReducer = {
	league: null,
};

export const manage_league = createReducer({}, initialState)
	.on(actions.fetchLeagueSuccess, (_store, payload) => ({
		...payload,
	}))
	.on(actions.fetchLeagueFailed, () => ({
		...initialState,
	}))
	.on(actions.postLeagueUpdateSuccess, (_state, payload) => ({
		...payload,
	}));
